export enum ERejectionReason {
  wrongAmount = "wrongAmount",
  amountNotApproved = "amountNotApproved",
  other = "other"
}

export const rejectionReasonList = [
  { id: ERejectionReason.wrongAmount, name: "Wrong amount keyed accidentally" },
  { id: ERejectionReason.amountNotApproved, name: "Amount not approved by sector lead" },
  { id: ERejectionReason.other, name: "Others" },
];

export const remarkTypeFormatter = (id: string): string => {
  const item = rejectionReasonList.find((type: any) => type.id === id);
  return item ? item.name : "";
};